import React from 'react';
import { ReactComponent as CustomWebhooksIcon } from 'qs-assets/Media/ic_webhooks.svg';
import './styles.scss';

export default ({ width, height, fill, classes = '' }) => {
  return (
    <CustomWebhooksIcon
      style={{ width, height, fill }}
      className={`settingsIconComponent ${classes}`}
    />
  );
};
